<app-page-header [header]="pageTitle" backgroundPath="assets/images/lead/lead-brief.jpg"></app-page-header>


<div class="container" style="padding-top: 30px;">
    <section class="section-select -menu visible-sm visible-xs show-on-min">
        <app-dropdown [title]="pageTitle" [valueDropdown]="valueDropdown" (selected)="selectValue($event)">
        </app-dropdown>
    </section>

    <ul class="nav nav-tabs tab-four show-on-max" id="myTab" role="tablist" style="width: 802px;">

        <li class="nav-item">
            <a class="nav-link {{choiceFromSelect==='option1'? 'active': ''}}" id="one-tab" data-toggle="tab"
                [routerLink]="['/FundRecommend','option1']" role="tab" aria-controls="one" aria-selected="false"
                href="#one">
                {{language.fundrecommmenutab1}}
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link {{choiceFromSelect==='option2'? 'active': ''}}" id="two-tab" data-toggle="tab"
                [routerLink]="['/FundRecommend','option2']" role="tab" aria-controls="two" aria-selected="false"
                href="#two">
                {{language.fundrecommmenutab2}}
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link {{choiceFromSelect==='option3'? 'active': ''}}" id="three-tab" data-toggle="tab"
                [routerLink]="['/FundRecommend','option3']" role="tab" aria-controls="three" aria-selected="false"
                href="#three">
                {{language.fundrecommmenutab3}}
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link {{choiceFromSelect==='option4'? 'active': ''}}" id="four-tab" data-toggle="tab"
                [routerLink]="['/FundRecommend','option4']" role="tab" aria-controls="four" aria-selected="false"
                href="#four">
                {{language.fundrecommmenutab4}}
            </a>
        </li>
    </ul>

    <div class="tab-content" id="myTabContent">
        <div [ngSwitch]="choiceFromSelect">

            <div *ngSwitchCase="'option1'" class="tab-pane fade show active" id="one" role="tabpanel"
                aria-labelledby="one-tab" style="padding-top: 30px">
                <div class="option1">
                    <section class="show-listing -highlight">
                        <div class="row">
                            <div class="col-ss-12 col-xs-4 col-sm-4" *ngFor="let item of rendermerket">
                                <div *ngIf="flag == 'th'; else elserendermerket">
                                    <section class="card -new">
                                        <header>
                                            <h2 #dot class="heading-topic insert-dotdotdot" data-mh="heading-topic"
                                                style="height: 80px;"> {{item.title}} </h2>
                                        </header>
                                        <div class="thumb view">
                                            <div class="desc-thumb">
                                                <a [routerLink]="['/th/market/detail',item.marketid]" class="desc">

                                                    <!-- Morning Brief -->
                                                    <time *ngIf="item.title == 'Morning Brief' || item.title == 'ONEAM Market Update' " class="date">
                                                        <span> {{ changeFormatDate_getdate(item.publicDate) }} </span>
                                                        <time
                                                            class="month-year">{{changeFormatDate_getMMyyyy(item.publicDate)}}</time>
                                                    </time>

                                                    <time *ngIf="item.title != 'Morning Brief' && item.title != 'ONEAM Market Update'" class="date">
                                                        <div *ngIf="check_month && item.title != 'One\'s View Monthly Outlook'; else elseBlock">
                                                            <span
                                                                style="font-size:38px;margin-right:10px;">{{ this.date_week }}</span>
                                                            <time
                                                                class="month-year">{{ changeFormatDate_getMMyyyy(this.date_now) }}
                                                            </time>
                                                            <span style="font-size:38px;"> - {{this.date_tmp}} </span>
                                                            <time
                                                                class="month-year">{{ changeFormatDate_getMMyyyy(this.date_tmp2) }}</time>
                                                        </div>
                                                        <ng-template #elseBlock>
                                                            <span>{{changeFormatDate_getDateEnd(item.publicDate)}}</span>
                                                            <time
                                                                class="month-year">{{ changeFormatDate_getMMyyyy(item.publicDate) }}</time>
                                                        </ng-template>
                                                    </time>


                                                    <span class="arrow-right">
                                                        <i class="icon icon-arrow-next"></i>
                                                    </span>
                                                </a>
                                            </div>
                                            <a [routerLink]="['/th/market/detail',item.marketid]" class="parent">
                                                <span *ngIf="item.market_img_Thum != ''" class="img-photo img-fluid"
                                                    [style.background-image]="getBackground(item.market_img_Thum)"></span>
                                            </a>
                                        </div>
                                    </section>
                                </div>
                                <ng-template #elserendermerket>
                                    <section class="card -new">
                                        <header>
                                            <h2 #dot class="heading-topic insert-dotdotdot" data-mh="heading-topic"
                                                style="height: 80px;"> {{item.title_en}} </h2>
                                        </header>
                                        <div class="thumb view">
                                            <div class="desc-thumb">
                                                <a [routerLink]="['/th/market/detail',item.marketid]" class="desc">

                                                    <!-- Morning Brief -->
                                                    <time *ngIf="item.title == 'Morning Brief' || item.title == 'ONEAM Market Update'" class="date">
                                                        <span> {{ changeFormatDate_getdate(item.publicDate) }} </span>
                                                        <time
                                                            class="month-year">{{item.publicDate | date:'MMMM yyyy'}}</time>
                                                    </time>

                                                    <time *ngIf="item.title != 'Morning Brief' && item.title != 'ONEAM Market Update'" class="date">
                                                        <div *ngIf="check_month; else elseBlock">
                                                            <span
                                                                style="font-size:38px;margin-right:10px;">{{ this.date_week }}</span>
                                                            <time
                                                                class="month-year">{{ this.date_now | date:'MMMM yyyy' }}
                                                            </time>
                                                            <span style="font-size:38px;"> - {{this.date_tmp}} </span>
                                                            <time
                                                                class="month-year">{{ this.date_tmp2 | date:'MMMM yyyy' }}</time>
                                                        </div>
                                                        <ng-template #elseBlock>
                                                            <span>{{changeFormatDate_getDateEnd(item.publicDate)}}</span>
                                                            <time
                                                                class="month-year">{{ item.publicDate  | date:'MMMM yyyy' }}</time>
                                                        </ng-template>
                                                    </time>

                                                    <span class="arrow-right">
                                                        <i class="icon icon-arrow-next"></i>
                                                    </span>
                                                </a>
                                            </div>
                                            <a [routerLink]="['/th/market/detail',item.marketid]" class="parent">
                                                <span *ngIf="item.market_img_Thum_en != ''" class="img-photo img-fluid"
                                                    [style.background-image]="getBackground(item.market_img_Thum_en)"></span>
                                            </a>
                                        </div>
                                    </section>
                                </ng-template>
                            </div>
                        </div>
                    </section>

                    <footer class="text-center" style="padding-top: 40px">
                        <app-paginator [currentPage]="marketCurrentPage" [totalPage]="totalmarketPage"
                            (currentPageNumber)="setCurrentmarketPage($event)"></app-paginator>
                    </footer>
                </div>
            </div>

            <div *ngSwitchCase="'option2'" class="tab-pane fade show active" id="two" role="tabpanel"
                aria-labelledby="two-tab" style="padding-top: 30px">

                <section class="show-listing -highlight">
                    <div *ngIf="flag == 'th'; else elsehighlight">
                        <div class="row">
                            <div *ngFor="let item of highlightFundRecommend" class="col-ss-12 col-xs-4 col-sm-4">
                                <section class="card -new ">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/newsletter/detail',item.newsletterid]" class="parent">
                                            <span *ngIf="item.newsletter_img_Thum != null" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.newsletter_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/newsletter/detail',item.newsletterid]">{{item.title}}</a>
                                        </h3>
                                        <time>{{changeFormatDate(item.publicDate)}}</time>
                                    </div>
                                    <!-- <ng-template #elsehighlight>
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/newsletter/detail',item.newsletterid]" class="parent">
                                            <span *ngIf="item.newsletter_img_Thum_en != null"
                                                class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.newsletter_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/newsletter/detail',item.newsletterid]">{{item.title_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </ng-template> -->
                                </section>
                            </div>
                        </div>
                    </div>
                    <ng-template #elsehighlight>
                        <div class="row">
                            <div *ngFor="let item of highlightFundRecommend" class="col-ss-12 col-xs-4 col-sm-4">
                                <section class="card -new ">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/newsletter/detail',item.newsletterid]" class="parent">
                                            <span *ngIf="item.newsletter_img_Thum_en != null" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.newsletter_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/newsletter/detail',item.newsletterid]">{{item.title_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </ng-template>
                </section>

                <section class="show-listing">
                    <div class="row">
                        <div *ngFor="let item of renderfundrecomm" class="col-ss-12 col-xs-6 col-lg-4">
                            <div *ngIf="flag == 'th'; else elseoption2">
                                <section *ngIf="item.title != ''" id="newsList-2" class="card -new">
                                    <div class="thumb-2 view">
                                        <a [routerLink]="['/th/newsletter/detail',item.newsletterid]" class="parent">
                                            <span *ngIf="item.newsletter_img_Thum != null" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.newsletter_img_Thum)"></span></a>
                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/newsletter/detail',item.newsletterid]">{{item.title}}</a>
                                        </h3>
                                        <time>{{changeFormatDate(item.publicDate)}} </time>
                                    </div>
                                </section>
                            </div>
                            <ng-template #elseoption2>
                                <section *ngIf="item.title_en != ''" id="newsList-2" class="card -new">
                                    <div class="thumb-2 view">
                                        <a [routerLink]="['/th/newsletter/detail',item.newsletterid]" class="parent">
                                            <span *ngIf="item.newsletter_img_Thum_en != null"
                                                class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.newsletter_img_Thum_en)"></span></a>
                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/newsletter/detail',item.newsletterid]">{{item.title_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </section>
                            </ng-template>
                        </div>
                    </div>
                </section>
                <footer class="text-center" style="padding-top: 40px">
                    <app-paginator [currentPage]="fundrecommCurrentPage" [totalPage]="totalfundrecommPage"
                        (currentPageNumber)="setCurrentfundrecommPage($event)"></app-paginator>
                </footer>
            </div>

            <div *ngSwitchCase="'option3'" class="tab-pane fade show active" id="three" role="tabpanel"
                aria-labelledby="three-tab" style="padding-top: 30px">
                <section class="show-listing -highlight">
                    <div *ngIf="flag == 'th'; else elsehighlightvdo">
                        <div class="row">
                            <div *ngFor="let item of highlightFundRecommend" class="col-ss-12 col-xs-4 col-sm-4">
                                <section class="card -new ">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/vdo/detail',item.vdoid]" class="parent">
                                            <span *ngIf="item.vdo_img_Thum != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.vdo_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a [routerLink]="['/th/vdo/detail',item.vdoid]">{{item.title}}</a>
                                        </h3>
                                        <time>{{changeFormatDate(item.publicDate)}}</time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <ng-template #elsehighlightvdo>
                        <div class="row">
                            <div *ngFor="let item of highlightFundRecommend" class="col-ss-12 col-xs-4 col-sm-4">
                                <section class="card -new ">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/vdo/detail',item.vdoid]" class="parent">
                                            <span *ngIf="item.vdo_img_Thum_en != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.vdo_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a [routerLink]="['/th/vdo/detail',item.vdoid]">{{item.title_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </section>
                            </div>
                        </div>

                    </ng-template>
                </section>

                <section class="show-listing">
                    <div *ngIf="flag == 'th'; else elsevdonot">
                        <div class="row">
                            <div *ngFor="let item of renderfundrecomm" class="col-ss-12 col-xs-6 col-lg-4">
                                <section *ngIf="item.title != ''" id="newsList-2" class="card -new">
                                    <div class="thumb-2 view">
                                        <a [routerLink]="['/th/vdo/detail',item.vdoid]" class="parent">
                                            <span *ngIf="item.vdo_img_Thum != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.vdo_img_Thum)"></span></a>
                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a [routerLink]="['/th/vdo/detail',item.vdoid]">{{item.title}}</a>
                                        </h3>
                                        <time>{{changeFormatDate(item.updateDate)}} </time>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                    <ng-template #elsevdonot>
                        <div class="row">
                            <div *ngFor="let item of renderfundrecomm" class="col-ss-12 col-xs-6 col-lg-4">
                                <section *ngIf="item.title_en != ''" id="newsList-2" class="card -new">
                                    <div class="thumb-2 view">
                                        <a [routerLink]="['/th/vdo/detail',item.vdoid]" class="parent">
                                            <span *ngIf="item.vdo_img_Thum_en != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.vdo_img_Thum_en)"></span></a>
                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a [routerLink]="['/th/vdo/detail',item.vdoid]">{{item.title_en}}</a>
                                        </h3>
                                        <time>{{item.updateDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </section>
                            </div>
                        </div>

                    </ng-template>
                </section>
                <footer class="text-center" style="padding-top: 40px">
                    <app-paginator [currentPage]="fundrecommCurrentPage" [totalPage]="totalfundrecommPage"
                        (currentPageNumber)="setCurrentfundrecommPage($event)"></app-paginator>
                </footer>
            </div>

            <div *ngSwitchCase="'option4'" class="tab-pane fade show active" id="four" role="tabpanel"
                aria-labelledby="four-tab" style="padding-top: 30px">

                <section class="show-listing -highlight">
                    <div class="row">
                        <div *ngFor="let item of highlightFundRecommend" class="col-ss-12 col-xs-4 col-sm-4">
                            <div *ngIf="flag == 'th'; else elsehighlightFundRecommend4">
                                <section class="card -new ">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]" class="parent">
                                            <span *ngIf="item.fundRecom_img_Thum != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.fundRecom_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]">{{item.title}}</a>
                                        </h3>
                                        <time>{{changeFormatDate(item.publicDate)}}</time>
                                    </div>
                                </section>
                            </div>
                            <ng-template #elsehighlightFundRecommend4>
                                <section class="card -new ">
                                    <div class="thumb view">
                                        <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]" class="parent">
                                            <span *ngIf="item.fundRecom_img_Thum_en != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.fundRecom_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]">{{item.title_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}}</time>
                                    </div>
                                </section>
                            </ng-template>
                        </div>
                    </div>
                </section>

                <section class="show-listing">
                    <div class="row">
                        <div *ngFor="let item of renderfundrecomm" class="col-ss-12 col-xs-6 col-lg-4">
                            <div *ngIf="flag == 'th'; else elserenderfundrecomm4">
                                <section *ngIf="item.title != ''" id="newsList-2" class="card -new">
                                    <div class="thumb-2 view">
                                        <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]" class="parent">
                                            <span *ngIf="item.fundRecom_img_Thum != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.fundRecom_img_Thum)"></span>
                                        </a>
                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]">{{item.title}}</a>
                                        </h3>
                                        <time>{{changeFormatDate(item.publicDate)}} </time>
                                    </div>
                                </section>
                            </div>
                            <ng-template #elserenderfundrecomm4>
                                <section *ngIf="item.title_en != ''" id="newsList-2" class="card -new">
                                    <div class="thumb-2 view">
                                        <a [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]" class="parent">
                                            <span *ngIf="item.fundRecom_img_Thum_en != ''" class="img-photo img-fluid"
                                                [style.background-image]="getBackground(item.fundRecom_img_Thum_en)"></span>
                                        </a>
                                    </div>
                                    <div class="info" style=" padding-left: 10px; padding-top: 0px;">
                                        <h3 #dot class="h6 topic-title insert-dotdotdot"
                                            style="overflow-wrap: break-word;">
                                            <a
                                                [routerLink]="['/th/fundrecomm/detail',item.fundRecomid]">{{item.title_en}}</a>
                                        </h3>
                                        <time>{{item.publicDate | date:'dd MMMM yyyy'}} </time>
                                    </div>
                                </section>
                            </ng-template>
                        </div>
                    </div>
                </section>
                <footer class="text-center" style="padding-top: 40px">
                    <app-paginator [currentPage]="fundrecommCurrentPage" [totalPage]="totalfundrecommPage"
                        (currentPageNumber)="setCurrentfundrecommPage($event)"></app-paginator>
                </footer>
            </div>
        </div>
    </div>
</div>